/**
 *  Component: Guide Section
 */
import React from 'react';

import { Grid } from '@material-ui/core';
import styled from 'styled-components';

import hrisImage from 'assets/images/illustrations/hrisIllustration.svg';

import { NotificationIcon1, ReviewFilledIcon, OneOnOneHeaderIcon } from 'constants/icons';

import { FormContainer, FormHeading, Separator, Icon } from '../styles';
import IconWithText from './iconWithText';

const GuideSection = () => (
  <FormContainer>
    <FormHeading>
      <Icon>
        <NotificationIcon1 size="fixed18px" />
      </Icon>
      On Mesh you'll get notified of the following
    </FormHeading>
    <Separator />
    <Container>
      <Grid container>
        <Grid xs="4" container direction="column" style={{ marginTop: '16px' }}>
          <Grid>
            <IconWithText
              icon={<OneOnOneHeaderIcon size="fixed24px" color="#3A8EE9" />}
              text="Automatically onboard new employees of the company"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<ReviewFilledIcon size="fixed24px" color="#3A8EE9" />}
              text="Automatically remove the employees once the employee quits"
            />
          </Grid>
        </Grid>
        <Grid xs="8" container justify="flex-end">
          <StrokedImage src={hrisImage} />
        </Grid>
      </Grid>
    </Container>
  </FormContainer>
);

const Container = styled.div`
  padding: 2rem 2rem 30px 24px;
`;

const StrokedImage = styled.img`
  height: 275px;
  ${'' /* border: 1px solid #eee; */}
`;

export default GuideSection;
